import { Bars, Shops, Sights } from '@lt/components/icons-react/map';
import { i18n } from '@lt/localization';

const borderRadius = '48px';

export const HEATMAP_LAYERS = [
  {
    id: 'hm_food_and_drinks',
    dataLayerName: 'cocktail',
    name: i18n.t('map.utils.cafe'),
    icon: Bars,
    activeBgColor: '#FFC20D',
    borderRadius: `
      border-top-left-radius: ${borderRadius};
      border-top-right-radius: ${borderRadius};
    `,
  },
  {
    id: 'hm_tourism',
    dataLayerName: 'museums',
    name: i18n.t('map.utils.place'),
    icon: Sights,
    activeBgColor: '#2B54A7',
    borderRadius: `
      border-radius: 0;
    `,
  },
  {
    id: 'hm_shopping',
    dataLayerName: 'shopping',
    name: i18n.t('map.utils.shopping'),
    icon: Shops,
    activeBgColor: '#25D97F',
    borderRadius: `
      border-bottom-right-radius: ${borderRadius};
      border-bottom-left-radius: ${borderRadius};
    `,
  },
] as const;
